<template lang="pug">
  .rounded.shadow-sm.p-2.border.w-100
    b-modal(:id="`delete-${componentId}`", body-class="overflow-hidden", centered, hide-header, hide-footer, scrollable)
      p.font-lg.font-weight-semibold.text-gray-900 Are you sure you want to delete {{ deleteMode === 'all'? 'all the files':'this file'}}?
      .d-flex.justify-content-end.mt-5
        n-button.mr-2(buttonText="Delete" type="button" variant="outline-danger" @click="deleteData")
        n-button(buttonText="Cancel" type="button" @click="$bvModal.hide(`delete-${componentId}`)")
    file-upload.d-none.position-absolute(
      @input-file="inputFile", 
      :size="maxSize",
      :accept="accept",
      :extensions="extensions",
      :name="type")
    .d-flex.justify-content-between.align-items-center.p-2.w-100
      .d-flex.align-items-center.w-75
        n-icon.mr-2(:name="noFiles?'ellipse-unselected':'check-circle'", :variant="noFiles?'gray-500':'teal-700'", :pathCount="2")
        span.font-weight-medium {{ type }}
      label.cursor-pointer.d-flex.align-items-center.m-0(v-if="noFiles", :for="type")
        n-icon.rounded.border.p-1.shadow-sm(name="upload", variant="blue-500", :size="1")
      n-icon.cursor-pointer(v-else name="delete", variant="red-500", @click="deleteFile()")
      
    .second.border-top.p-4.text-center(v-if="loading")
      b-spinner(:show="loading")
    .second.border-top(v-else-if="!noFiles")
      .row.px-2.mt-2
        .col-4.mt-3(v-for="(file, index) in allFiles" :key="file.id")
          .d-flex.justify-content-center.rounded.bg-gray-500.py-2.position-relative
            .d-flex.justify-content-center.position-absolute.border.rounded-circle.cancel-icon.bg-white
              n-icon.cursor-pointer(name="cross", variant="gray-900", :size="1", @click="deleteFile(index)")
            n-icon.cursor-pointer(name="eye", variant="gray-900", @click="preview(file)")
          .d-flex.justify-content-center.mt-1
            span.font-sm.text-truncate {{ file.name }}
          
      .d-flex.justify-content-center.pt-4.pb-1
        label.text-blue-500.font-sm.font-weight-medium.cursor-pointer(:for="type") + Add More
</template>

<script>
import FileUpload from "vue-upload-component";
import { kebabCase } from "lodash";
import adminResDefs from "../../../admin/definitions";
import NButton from "@/components/NovaButton.vue";

export default {
  components: {
    FileUpload,
    NButton,
  },
  props: {
    type: {
      type: String,
      default: () => null,
    },
    value: {
      type: Array,
      default: () => [],
    },
    accept: {
      type: String,
      default: "image/png,image/gif,image/jpeg,image/webp,text/pdf,pdf,application/pdf",
    },
    extensions: {
      type: String,
      default: "gif,jpg,jpeg,png,webp,pdf,doc",
    },
  },
  data() {
    const allFiles = [...this.value];
    const id = kebabCase(this.type);
    return {
      allFiles,
      loading: false,
      selectedFile: null,
      deleteMode: "all",
      componentId: id,
      maxSize: 1024 * 1024 * 50, // 50 MB
    };
  },
  computed: {
    noFiles() {
      return this.allFiles.length < 1;
    },
  },
  watch: {
    value(val) {
      this.allFiles = val;
    },
  },
  methods: {
    preview(file) {
      if (file.url) window.open(file.url, "_blank");
    },
    deleteFile(idx = null) {
      if (idx !== null) {
        this.selectedFile = idx;
        this.deleteMode = "single";
      } else {
        this.deleteMode = "all";
      }
      this.$bvModal.show(`delete-${this.componentId}`);
    },
    deleteData() {
      if (this.deleteMode === "all") {
        this.allFiles = [];
      } else {
        this.allFiles.splice(this.selectedFile, 1);
      }
      this.$emit("input", this.allFiles);
      this.$bvModal.hide(`delete-${this.componentId}`);
    },
    async inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        if (newFile.size >= 0 && newFile.size <= this.maxSize) {
          await this.sendToDB(newFile);
        } else {
          this.$store.commit("clearAlerts");
          this.$store.commit("addAlert", {
            variant: "danger",
            message: "File size too large!",
          });
        }
      }
    },
    async sendToDB(newFile) {
      this.loading = true;
      try {
        const result = await this.$apollo.mutate({
          mutation: adminResDefs.files.upsertMutation,
          variables: {
            file: newFile.file,
            meta: {
              type: "img",
            },
            action: "batchUpload",
            uploadingUserId: this.$store.state.user.id,
          },
        });
        this.allFiles.unshift({
          docType: this.type,
          type: result.data.upsertFile.file.meta.type,
          url: result.data.upsertFile.file.url,
          name: result.data.upsertFile.file.name,
          id: result.data.upsertFile.file.id,
        });
        this.$emit("input", this.allFiles);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.$store.commit("addAlert", {
          variant: "danger",
          message: "Something went wrong, unable to upload file.",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cancel-icon {
  top: 0;
  right: 0;
  transform: translate(30%, -30%);
}
</style>
